import { CheckCircleIcon } from '@systemeio/ui/icons'
import { SuccessButton } from '@systemeio/ui'
import { EmailTemplateItemInterface } from 'modules/email/types/email-template-interface'
import React from 'react'
import { Loader } from 'shared/components/loader'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { useIsTouchDevice } from 'shared/hooks/use-is-touch-device'

export interface EmailTemplateSelectorProps {
  templates?: EmailTemplateItemInterface[]
  templateId?: number
  onChange: (templateId: number) => void
}

const EmailTemplateSelector = ({ onChange, templateId, templates }: EmailTemplateSelectorProps) => {
  const { t } = useLocoTranslation()

  const isTouchDevice = useIsTouchDevice()

  return (
    <div className={`overflow-auto`}>
      <ul className={`flex flex-col flex-wrap items-center justify-center gap-5 pb-5 sm:flex-row`}>
        {templates?.map((template, idx) => {
          return (
            <li key={idx}>
              <div
                className={`focus-visible:border-brand-primary group relative flex h-[250px] w-[230px] flex-col items-center justify-start overflow-hidden rounded-lg border-2 border-transparent shadow-lg outline-hidden sm:h-[260px] sm:w-[230px] ${
                  template.id === templateId && 'border-green'
                } main-transition-colors`}
                onClick={isTouchDevice ? () => onChange(template.id) : undefined}
              >
                <div
                  className={`z-1 bg-background-secondary/70 h-full w-full rounded-lg ${
                    templateId === template.id ? '' : 'hidden group-hover:flex'
                  } flex flex-col items-center justify-center gap-5 justify-self-stretch`}
                >
                  {template.id === templateId ? (
                    <div className={`flex h-[40px] max-w-[180px] items-center gap-1`}>
                      <CheckCircleIcon className={'fill-green'} />
                      <span className={'text-green break-all font-bold'}>
                        {t('dashboard.email_template_selector.template_selected')}
                      </span>
                    </div>
                  ) : (
                    <SuccessButton
                      onClick={async (e: React.MouseEvent<HTMLButtonElement>) => {
                        e.preventDefault()
                        onChange(template.id)
                      }}
                      className={'max-w-[180px]'}
                    >
                      <CheckCircleIcon className={'fill-background-secondary h-[20px] w-[20px]'} />
                      <span className={'text-background-secondary break-words'}>
                        {t('dashboard.email_template_selector.select_template')}
                      </span>
                    </SuccessButton>
                  )}
                </div>
                <img
                  src={template.previewUrl || ''}
                  className={`absolute h-full rounded-lg object-cover`}
                />
              </div>
            </li>
          )
        }) || <Loader className="mx-auto" />}
      </ul>
    </div>
  )
}

export default EmailTemplateSelector
